
export const DIAGRAM_TYPES = Object.freeze({
    NODE: "node-diagram",
    TABBED: "tabbed-diagram",
    STATE: "state-diagram",
    CUSTOM: "custom-diagram",
    PLACEHOLDER: "placeholder",
  });
  